var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meta-item-back mt-3"},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.text))]),_c('i',{class:['icon', _vm.type_arrow]})])
}
var staticRenderFns = []

export { render, staticRenderFns }